import{h as o}from"./chunk-HYY6XO3Z.js";import{a as r}from"./chunk-DI2XYJKC.js";import{m as t}from"./chunk-HBP5N4FR.js";t();function g(){return o(r.getState())}export{g as a};
//# sourceMappingURL=chunk-6JKYVDD7.js.map
